import { ReactComponent as GearFromFile } from '@/assets/images/svg/glyphs/gear.svg';
import type { FC, SVGProps } from 'react';

/**
 * Each glyph’s source file lives under `src/assets/…`. At build time, Next.js runs those `.svg`
 * files through SVGR (`@svgr/webpack`, wired in `src/next-config/webpack.js`) and exposes them as
 * `ReactComponent`. That’s what we want to render whenever it’s available.
 *
 * Storybook is wired through `@storybook/nextjs`, which normally reuses that same webpack setup.
 * In practice, webpack merges and version bumps don’t always match the main app exactly. When SVGR
 * doesn’t run for a given bundle, `ReactComponent` can be `undefined`. Anything that wraps the
 * icon at module load — for example `styled(SomeGlyph)` — then throws an error before your story renders.
 *
 * The inline SVG below mirrors the asset so icons still show up in Storybook (and any other
 * environment where the loader chain differs) instead of taking down the module graph.
 */
const FallbackGear: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="presentation" {...props}>
    <path
      fill="currentColor"
      d="M12 15.5A3.5 3.5 0 1 0 12 8.5a3.5 3.5 0 0 0 0 7Zm7.43-2.53c.04-.32.07-.66.07-1s-.03-.68-.07-1l2.11-1.65-2-3.46-2.43 1c-.52-.4-1.08-.73-1.69-.99l-.38-2.65H8.56l-.38 2.65c-.61.26-1.17.59-1.69.99l-2.43-1-2 3.46 2.11 1.65c-.04.32-.07.66-.07 1s.03.68.07 1l-2.11 1.65 2 3.46 2.43-1c.52.4 1.08.73 1.69.99l.38 2.65h4.87l.38-2.65c.61-.26 1.17-.59 1.69-.99l2.43 1 2-3.46-2.11-1.65Z"
    />
  </svg>
);

export const GearGlyph: FC<SVGProps<SVGSVGElement>> =
  typeof GearFromFile === 'function' ? GearFromFile : FallbackGear;
